import Tooltip from './src/tooltip';

module.exports = Tooltip;


// WEBPACK FOOTER //
// ./src/components/tooltip/index.js